module.exports = __webpack_public_path__ + "static/media/wave-about.b67f0a93.svg";